import React from 'react'
import { List } from '@fs/zion-ui'
import CustomPerson from './CustomPerson'

function CoupleListItem({ person, highlight, showGenderText, hidePids, customPersonLinkOrOverlay }) {
  return (
    <CustomPerson
      person={person}
      showGenderText={showGenderText}
      hidePids={hidePids}
      customPersonLinkOrOverlay={customPersonLinkOrOverlay}
      highlight={highlight}
    />
  )
}

const TempCouple = ({ parent1, parent2, hidePids, focusPersonId, showGenderText, customPersonLinkOrOverlay }) => {
  const commonProps = {
    showGenderText,
    hidePids,
    customPersonLinkOrOverlay,
  }

  return (
    <List>
      {parent1?.id && focusPersonId === parent1?.id && <CoupleListItem person={parent1} highlight {...commonProps} />}
      {parent1?.id && focusPersonId !== parent1?.id && <CoupleListItem person={parent1} {...commonProps} />}
      {parent2?.id && focusPersonId === parent2?.id && <CoupleListItem person={parent2} highlight {...commonProps} />}
      {parent2?.id && focusPersonId !== parent2?.id && <CoupleListItem person={parent2} {...commonProps} />}
    </List>
  )
}

export default TempCouple
